var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignalLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H1C0.723858 15 0.5 15.2239 0.5 15.5V20.5C0.5 20.7761 0.723858 21 1 21H3C3.27614 21 3.5 20.7761 3.5 20.5V15.5C3.5 15.2239 3.27614 15 3 15Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H6C5.72386 12 5.5 12.2239 5.5 12.5V20.5C5.5 20.7761 5.72386 21 6 21H8C8.27614 21 8.5 20.7761 8.5 20.5V12.5C8.5 12.2239 8.27614 12 8 12Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H11C10.7239 9 10.5 9.22386 10.5 9.5V20.5C10.5 20.7761 10.7239 21 11 21H13C13.2761 21 13.5 20.7761 13.5 20.5V9.5C13.5 9.22386 13.2761 9 13 9Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H16C15.7239 6 15.5 6.22386 15.5 6.5V20.5C15.5 20.7761 15.7239 21 16 21H18C18.2761 21 18.5 20.7761 18.5 20.5V6.5C18.5 6.22386 18.2761 6 18 6Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H21C20.7239 3 20.5 3.22386 20.5 3.5V20.5C20.5 20.7761 20.7239 21 21 21H23C23.2761 21 23.5 20.7761 23.5 20.5V3.5C23.5 3.22386 23.2761 3 23 3Z",
    fill: "#808080",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalLoading);
export default __webpack_public_path__ + "static/media/signalLoading.eae23b49.svg";
export { ForwardRef as ReactComponent };